import React from 'react'

import { barePathCodec } from '../pathMapping/paths'
import { TokenListFields } from '../pathMapping/TokenListFields'

import { GENERIC_FIELDS } from './genericFields'
import { GenericPathHelp } from './GenericPathHelp'

export const GenericCampaignNameFields = () => (
  <TokenListFields
    field={GENERIC_FIELDS.campaignNameFields}
    label="VOIP Campaign Name"
    codec={barePathCodec}
    testIdPrefix="generic-campaign"
    columnLabels={['Path']}
    addLabel="Add path"
    removeLabel="Remove campaign name path"
    placeholder="queue.name"
    separator="_"
    help={<GenericPathHelp />}
    caption="Values are joined with an underscore in row order. A path that resolves to nothing is skipped; if none resolve the campaign name is left unset."
  />
)
